function getOtherAcceptedRedlined(blocks, agreement) {
  let hasOtherAcceptedRedline = false;

  if (agreement) {
    for (let i = 0; i < blocks.length; i++) {
      const section = blocks[i];
      const sentences = agreement.sentences || [];
      const acceptedSentences = sentences.filter(
        (item) =>
          item.section.replace(/\s/g, '') !== section &&
          item.section.replace(/\s/g, '') !== `${section}title`
      );
      hasOtherAcceptedRedline = acceptedSentences.length > 0;
      if (hasOtherAcceptedRedline) break;
    }
  }
  return hasOtherAcceptedRedline;
}

export default getOtherAcceptedRedlined;



// WEBPACK FOOTER //
// src/components/Deals/DealEditPages/helpers/getOtherAcceptedRedlined.js